module.exports = "<div class=\"filterContainer\">\r\n  <ng-template *ngIf=\"template\" [ngTemplateOutlet]=\"template\"></ng-template>\r\n</div>\r\n"